<script>
  export let x;
  export let y;
  export let bin;
  let container;
  import { scaleLinear } from "d3-scale";
  import { t, lang } from "../i18n";

  $: containerWidth = container ? container.parentElement.clientWidth : 300;

  $: arrowX = x * containerWidth;
  $: arrowY = 0.12;
  $: offsetX = scaleLinear().domain([0, 100]).range([-0.1, -0.97])(x);
  $: binRange = bin.max === 99 ? `${bin.min}+` : `${bin.min}-${bin.max}`;
  // $: offsetX = -0.5;
</script>

<div class="tooltip-container" style="left: {x}%; top: {y}%" bind:this={container}>
  <div class="tooltip" style="transform: translate({offsetX * 100}%, 0)">
    <div class="tooltip-inner">
      <span class="count"
        >{bin.count}
        {t(bin.count === 1 ? "histogram-measuring-point-singular" : "histogram-measuring-point-plural", $lang)}</span
      >
      <span class="no2"
        >NO<sub style="font-size: 0.6em">2</sub>: {binRange} µg/m<sup style="font-size: 0.6em">3</sup></span
      >
    </div>
  </div>
</div>

<style>
  .tooltip-container {
    position: absolute;
    width: 0;
    height: 0;
    top: 0;
    left: 0;
    z-index: 899;
    pointer-events: none;
  }

  .tooltip-container:after {
    content: "";
    position: absolute;
    bottom: 11px;
    left: -10px;
    width: 0;
    height: 0;
    border-top: solid 10px white;
    border-left: solid 10px transparent;
    border-right: solid 10px transparent;
  }

  .tooltip {
    box-sizing: border-box;
    background-color: #fff;
    border-radius: 3px;
    box-shadow: 0 2px 6px #00000026;
    pointer-events: none;
    position: absolute;
    letter-spacing: 0.025em;
    font-size: 15px;
    line-height: 20px;
    display: inline-block;
    left: 0;
    bottom: 20px;
  }

  .tooltip-inner {
    display: block;
    min-width: 100px;
    height: 100%;
    padding: 12px 15px 9px;
    white-space: nowrap;
  }

  .tooltip span {
    display: block;
  }

  .count {
    font-size: 10px;
    line-height: 10px;
    font-weight: 500;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    border-bottom: 1px rgba(0, 0, 0, 0.15) solid;
    margin-bottom: 6px;
    padding-bottom: 7px;
    color: #454545;
  }

  .no2 {
    font-weight: 700;
    letter-spacing: 0;
  }
</style>
